/*
	FRC Insta Feed
	Instagram API utilities for Fox Restaurant Concepts
	
	____________________________________________________

	USAGE

	var myFeed = new Insta({
					brand_id: '32557d34-3224-11e7-94ab-d37354a51af9', // Brand ID from FRC API
					name: 'frc-instagram', // Name used to identify cached feed
					template: '<img src="{{images.standard_resolution.url}}">', // Handlebars template for generating HTML
					cache: { // Optional
						use: true, // Default: true
						expires: 21600 // Value in seconds - Defaults to 21600 / 6 hours
					},
					onInit: function() { // Callback function - executes after feed is loaded
						console.log('Instagram feed retrieved.');
					}
				});

	METHODS

	myFeed.Posts(intOffset = 0, intLimit = 0, boolOutput = false, strTemplate = null);

		Returns an array of posts starting from intOffset (zero-based) to intLimit.
		If intLimit is not set, returns all available posts starting from intOffset.

		Alternatively, if boolOutput is set to true, returns a string with all posts
		starting from intOffset to intLimit, wrapped in the strTemplate markup.

		If a template is not provided but boolOutput is true, the method will return false.

	
	myFeed.getPost(intIndex = 0)

		Returns the post with the index intIndex (zero-based).
		If intIndex is not set, will return the latest post from the feed.


	myFeed.writePost(objIndex = 0, strTemplate = null)

		Returns a string with the post of index objIndex (zero-based), wrapped in the
		strTemplate markup.

		Alternatively, objIndex can be an array of post indices. If objIndex is provided
		as an array, function returns a string with posts whose indices match the values
		of the array, wrapped in the strTemplate markup.

		If objIndex is not provided, function returns markup for the latest post from the feed.

		If strTemplate is null, function returns false.


	myFeed.Clear()

		Clears cached feed from local storage.


	myFeed.destroy(boolStorage = false)

		Destroys feed object.

		If boolStorage is set to true, also clears cached feed from local storage.

*/

(function(factory) {
	if (typeof define === 'function' && define.amd && define.amd.jQuery) {
		define(['jquery'], factory);
	}
	else if (typeof module !== 'undefined' && module.exports) {
		factory(require('jquery'));
	}
	else {
		factory(jQuery);
	}
}(function($) {
	'use strict';

	var Insta = function(params) {

		var defaults = {
			api: frcContext.apiBaseUrl + 'brands',
			endpoint: '/{{brand_id}}/social/instagram',
			cache: {
				use: true,
				expires: 21600
				}
        };

		if (!(this instanceof Insta)) {
			return new Insta(params);
		}

		if ((typeof params) !== 'object') {
			console.log('%c%s', 'color: red', 'Insta error: Invalid parameters.');
			return false;
		}

		var I = this;

		params = params || {};
		var originalParams = {};
		for (var param in params) {
			if (typeof params[param] === 'object' && params[param] !== null && !(params[param].nodeType || params[param] === window || params[param] === document || (typeof Dom7 !== 'undefined' && params[param] instanceof Dom7) || (typeof jQuery !== 'undefined' && params[param] instanceof jQuery))) {
				originalParams[param] = {};
				for (var deepParam in params[param]) {
					originalParams[param][deepParam] = params[param][deepParam];
				}
			}
			else {
				originalParams[param] = params[param];
			}
		}
		for (var def in defaults) {
			if (typeof params[def] === 'undefined') {
				params[def] = defaults[def];
			}
			else if (typeof params[def] === 'object') {
				for (var deepDef in defaults[def]) {
					if (typeof params[def][deepDef] === 'undefined') {
						params[def][deepDef] = defaults[def][deepDef];
					}
				}
			}
		}

		I.params = params;

		I.Posts = function(intOffset, intLimit, boolOutput, strTemplate) {
			if (!intOffset) {
				intOffset = 0;
			}

			var posts = [];
			window.iFeed = I.feed;

			if (!intLimit) {
				for (var i = intOffset; i < I.feed.length; i++) {
					console.log(I.feed[i]);
					posts.push(I.feed[i]);
				}
			}
			else {
				var max = intOffset + intLimit;
				for (var i = intOffset; i < max; i++) {
					posts.push(I.feed[i]);
				}
			}

			if (boolOutput) {
				if (!strTemplate) {
					if (I.params.template) {
						var strTemplate = I.params.template;
					}
					else {
						return false;
					}
				}
				var template = Handlebars.compile(strTemplate),
					html = '';

				for (var i = 0;i < posts.length; i++) {
					html += template(posts[i]);
				}
				return html;

			}
			else {
				return posts;
			}
		},

		I.getPost = function(intIndex) {
			if (!intIndex) {
				intIndex = 0;
			}

			if ((typeof I.feed[intIndex]) !== 'object') {
				return false;
			}
			else {
				return I.feed[intIndex];
			}
		},

		I.writePost = function(objIndex, strTemplate) {
			if (!objIndex) {
				objIndex = 0;
			}

			if (!strTemplate) {
				if (I.params.template) {
					var strTemplate = I.params.template;
				}
				else {
					return false;
				}
			}

			var template = Handlebars.compile(strTemplate),
				html = '';

			if (objIndex instanceof Array) {
				for (var i = 0; i < objIndex.length; i++) {
					html += template(I.getPost(objIndex[i]));
				}
				return html;
			}
			else if (!isNaN(objIndex)) {
				html = template(I.getPost(objIndex));
				return html;
			}
			else {
				//console.log('%c%s', 'color: red', 'Insta error: Expecting integer or array.');
				return false;
			}
		},

		I.Clear = function() {
			localStorage.removeItem(I.params.name +'-feed');
			localStorage.removeItem(I.params.name +'-expires');
		},

		I.destroy = function(boolStorage) {
			if (boolStorage) {
				I.Clear();
			}

			I = null;
			Insta = null;
		},

		I.Init = function() {
			var url = I.params.api + I.params.endpoint,
				now = Math.round((new Date()).getTime() / 1000),
				localItem = I.params.name +'-feed';
			url = url.replace('{{brand_id}}', I.params.brand_id);

			if (params.cache.use && (localStorage.getItem(I.params.name +'-expires') && (now < localStorage.getItem(I.params.name +'-expires')))) {
				I.feed = JSON.parse(localStorage.getItem(localItem));
				
				if ((typeof I.feed) === 'object') {
					if ((typeof params.onInit) === 'function') {
						window.setTimeout(function() { params.onInit(); }, 2);
					}
					return I;
				}
				else {
					return false;
				}
			}
			else {
				$.when($.getJSON(url))
					.then(function(feed, textStatus, jqXHR) {
						if (jqXHR.status == 200) {
							I.feed = feed.data;
							if (params.cache.use) {
								localStorage[I.params.name + '-expires'] = now + I.params.cache.expires;
								localStorage[localItem] = JSON.stringify(feed.data);
							}

							if ((typeof I.feed) === 'object') {
								if ((typeof params.onInit) === 'function') {
									params.onInit();
								}
								return I;
							}
							else {
								return false;
							}
						}
						else {
							//console.log('%c%s', 'color: red', 'Insta error: Could not fetch Instagram feed. '+ jqXHR.status);
							return false;
						}
					}
				);
			}
		};

		I.Init();
	};
	window.Insta = Insta;
}));